module.exports = __webpack_public_path__ + "media/images/cms/logo_brand_02-51a21d4e4e622dc62890d214624a89fd.png";